export const getAllLanguagesAvailable = () =>
  Array.from(
    new Set(
      require
        .context('../../public/locales', true, /^\.\/([^/]+)\/.*$/)
        .keys()
        .map(key => key.replace(/^\.\/([^\/]*)\/.*$/, '$1')),
    ),
  );
